"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var Button_1 = require("@mui/material/Button");
var Modal_1 = require("@mui/material/Modal");
var react_1 = require("react");
var TextField_1 = require("@mui/material/TextField");
var Stack_1 = require("@mui/material/Stack");
var FormGroup_1 = require("@mui/material/FormGroup");
var FormControlLabel_1 = require("@mui/material/FormControlLabel");
var Checkbox_1 = require("@mui/material/Checkbox");
var material_1 = require("@mui/material");
var dayjs = require("dayjs");
var User_1 = require("../models/User");
var Toast_1 = require("../shared/utilities/Toast");
//import dayjs from 'dayjs' // ES 2015
dayjs().format();
var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
var VisuallyHiddenInput = styles_1.styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
var UserModal = react_1.forwardRef(function (props, ref) {
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var _b = Toast_1.default(), showErrorMessage = _b.showErrorMessage, showSuccessMessage = _b.showSuccessMessage;
    var _c = React.useState(''), id = _c[0], setId = _c[1];
    var _d = React.useState(''), firstName = _d[0], setFirstName = _d[1];
    var _e = React.useState(false), isInvalid = _e[0], setIsInvalid = _e[1];
    var _f = React.useState(''), lastName = _f[0], setLastName = _f[1];
    var _g = React.useState(''), email = _g[0], setEmail = _g[1];
    var _h = React.useState(''), role = _h[0], setRole = _h[1];
    var _j = React.useState(true), isActive = _j[0], setIsActive = _j[1];
    var _k = React.useState(false), sendResetPasswordLink = _k[0], setSendResetPasswordLink = _k[1];
    var _l = React.useState(false), isMobile = _l[0], setIsMobile = _l[1];
    var _m = React.useState(false), emailSubscription = _m[0], setEmailSubscription = _m[1];
    //choose the screen size 
    var handleResize = function () {
        if (window.innerWidth < 720) {
            setIsMobile(true);
        }
        else {
            setIsMobile(false);
        }
    };
    var handleOpen = function (user) {
        setOpen(true);
        setId(user.UserId);
        setFirstName(user.FirstName);
        setLastName(user.LastName);
        setEmail(user.Email);
        setRole(user.Role);
        setIsActive(user.IsActive);
        setEmailSubscription(user.EmailSubscription);
        setIsInvalid(user.UserId !== '');
        window.addEventListener("resize", handleResize);
        handleResize();
    };
    var handleClose = function () {
        setOpen(false);
        window.removeEventListener("resize", handleResize);
    };
    react_1.useImperativeHandle(ref, function () { return ({
        handleOpen: handleOpen
    }); });
    var handleFirstNameChange = function (e) {
        setFirstName(e.target.value);
    };
    var handleLastNameChange = function (e) {
        setLastName(e.target.value);
    };
    var handleEmailChange = function (e) {
        setEmail(e.target.value);
    };
    var handleRoleChange = function (e) {
        setRole(e.target.value);
    };
    var handleSendResetPasswordLinkChange = function (e) {
        setSendResetPasswordLink(e.target.checked);
    };
    var handleIsActiveChange = function (e) {
        setIsActive(e.target.checked);
    };
    var handleEmailSubscriptionChange = function (e) {
        setEmailSubscription(e.target.checked);
    };
    return (React.createElement(Modal_1.default, { open: open, onClose: handleClose, "aria-labelledby": "parent-modal-title", "aria-describedby": "parent-modal-description" },
        React.createElement(Box_1.default, { sx: __assign(__assign({}, style), { width: isMobile ? '90%' : '50%', overflowY: 'auto', maxHeight: '85%' }) },
            React.createElement(TextField_1.default, { label: "First Name", fullWidth: true, variant: "outlined", error: isInvalid && firstName === "", helperText: isInvalid && firstName === "" ? 'First name is required' : '', margin: "normal", onChange: handleFirstNameChange, value: firstName, inputProps: { maxLength: 100 } }),
            React.createElement(TextField_1.default, { label: "Last Name", fullWidth: true, variant: "outlined", margin: "normal", error: isInvalid && lastName === "", helperText: isInvalid && lastName === "" ? 'Last name is required' : '', onChange: handleLastNameChange, value: lastName, inputProps: { maxLength: 100 } }),
            React.createElement(TextField_1.default, { label: "Email", fullWidth: true, variant: "outlined", margin: "normal", onChange: handleEmailChange, value: email, error: isInvalid && email === "", helperText: isInvalid && email === "" ? 'Email is required' : '', inputProps: { maxLength: 250 } }),
            React.createElement(TextField_1.default, { select: true, margin: "normal", fullWidth: true, variant: "outlined", label: "Role", onChange: handleRoleChange, value: role, error: isInvalid && role === "", helperText: isInvalid && role === "" ? 'Role is required' : '' },
                React.createElement(material_1.MenuItem, { value: "User" }, "User"),
                React.createElement(material_1.MenuItem, { value: "Admin" }, "Admin")),
            id === '' &&
                React.createElement(FormGroup_1.default, null,
                    React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, { onChange: handleSendResetPasswordLinkChange }), label: "Send Reset Password Link" })),
            id !== '' &&
                React.createElement(FormGroup_1.default, null,
                    React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, { checked: isActive, onChange: handleIsActiveChange }), label: "Active" })),
            React.createElement(FormGroup_1.default, null,
                React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, { checked: emailSubscription, onChange: handleEmailSubscriptionChange }), label: "Post Email Subscription" })),
            React.createElement(Stack_1.default, { spacing: 2, direction: "row", justifyContent: "flex-end" },
                React.createElement(Button_1.default, { variant: "outlined", onClick: function () {
                        handleClose();
                    } }, "Cancel"),
                React.createElement(Button_1.default, { variant: "contained", onClick: function () {
                        if (firstName.trim() === "" || lastName.trim() === "" || email.trim() === "" || role.trim() === "") {
                            setIsInvalid(true);
                            showErrorMessage('User information is not valid!');
                            return;
                        }
                        var user = new User_1.UserModel();
                        user.UserId = id;
                        user.FirstName = firstName;
                        user.LastName = lastName;
                        user.Email = email;
                        user.Role = role;
                        user.IsActive = isActive;
                        user.EmailSubscription = emailSubscription;
                        props.upsertUser(user, sendResetPasswordLink);
                        handleClose();
                    } }, "Confirm")))));
});
exports.default = UserModal;
//# sourceMappingURL=UserModal.js.map